import type { FriendsMetric } from "./FRIENDS_METRICS";
import type { PeriodStats } from "./FriendsBoard";

// Порядок ранга для сортировки: тир × 6 + подуровень (`rank_badge` 53 — Mystic 3).
export const rankOrder = (badge: number): number => Math.floor(badge / 10) * 6 + (badge % 10);

// Значение показателя за период. Нет матчей или нечего считать (нет оценок, нет ранга) —
// `null`: игрок уходит в конец таблицы без места.
export const metricValue = (metric: FriendsMetric, stats: PeriodStats): number | null => {
  if (stats.matches === 0) {
    return null;
  }
  switch (metric) {
    case "score":
      return stats.score;
    case "winRate":
      return stats.wins / stats.matches;
    case "kda":
      return (stats.kills + stats.assists) / Math.max(stats.deaths, 1);
    case "soulsPerMinute":
      return stats.duration_s > 0 ? stats.net_worth / (stats.duration_s / 60) : null;
    case "deaths":
      return stats.deaths / stats.matches;
    case "rank":
      return stats.rank_badge === null ? null : rankOrder(stats.rank_badge);
    case "matches":
      return stats.matches;
  }
};
